import React from 'react';

import { EPanelOpenMethod } from '@components/block-event-single/store';
import {
  EventInfoCardContainer,
  EventInfoContainer,
  EventInfoName,
  EventInfoWrapper,
  EventTitle,
  StyledAntInput,
  StyledAntSelect,
  StyledAntTextArea,
} from '@components/detail-panel/components/EventInfoCard/styled';
import {
  EEventInfoKey,
  IEventInfoCard,
} from '@components/detail-panel/components/EventInfoCard/typed';
import { EEventManagementTabsType } from '@src/common/constant/enum';

const eventTitle = 'Download Success';
const eventDescription =
  'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. ';

const EditableInfoPanel: React.FC<{
  mode?: EPanelOpenMethod;
  name?: string;
  editComponent?: React.ReactNode;
  viewComponent?: React.ReactNode;
}> = ({ mode, name, editComponent, viewComponent }) => {
  return (
    <EventInfoWrapper>
      <EventInfoName>{name}</EventInfoName>
      {mode === 'edit' ? editComponent : viewComponent}
    </EventInfoWrapper>
  );
};

const CommonTextArea: React.FC<{
  value?: string;
  onChange?: (e: any) => void;
  disabled?: boolean;
}> = ({ value, onChange, disabled }) => (
  <StyledAntTextArea
    value={value}
    onChange={onChange}
    disabled={disabled}
    placeholder="Add a note..."
    autoSize
    style={{ height: '58px' }}
    maxLength={500}
    bordered={!disabled}
  />
);

const CommonSelect: React.FC<{
  value?: string;
  onChange?: (e: any) => void;
  disabled?: boolean;
}> = ({ value, onChange, disabled }) => (
  <StyledAntSelect
    value={value}
    onChange={onChange}
    disabled={disabled}
    bordered={!disabled}
    showArrow={!disabled}
  />
);

const EventInfoCard: React.FC<IEventInfoCard> = ({
  mode,
  type = EEventManagementTabsType.MAPPED_EVENT,
  blockEvent,
  mappedEvent,
  onChangeEventInfo,
}) => {
  let event: any = mappedEvent;
  if (type === EEventManagementTabsType.BLOCKED_EVENT) {
    event = blockEvent;
  }

  const EditableInfoPanelKit = {
    [EEventManagementTabsType.MAPPED_EVENT]: (
      <EventInfoContainer>
        <EditableInfoPanel
          mode={mode}
          name="Mapped Name:"
          editComponent={
            <StyledAntInput
              value={event?.event_name}
              onChange={(e) =>
                onChangeEventInfo?.({
                  type,
                  key: EEventInfoKey.EVENT_NAME,
                  value: e.target.value,
                })
              }
            />
          }
          viewComponent={<StyledAntInput value={event?.event_name} disabled bordered={false} />}
        />
        <EditableInfoPanel
          mode={mode}
          name="Event Category:"
          editComponent={
            <CommonSelect
              value={event?.event_category}
              onChange={(e) =>
                onChangeEventInfo?.({
                  type,
                  key: EEventInfoKey.EVENT_CATEGORY,
                  value: e.target.value,
                })
              }
            />
          }
          viewComponent={<CommonSelect value={event?.event_category} disabled />}
        />
        <EditableInfoPanel
          mode={mode}
          name="Description:"
          editComponent={
            <CommonTextArea
              value={event?.description}
              onChange={(e) =>
                onChangeEventInfo?.({
                  type,
                  key: EEventInfoKey.DESCRIPTION,
                  value: e.target.value,
                })
              }
            />
          }
          viewComponent={<CommonTextArea disabled value={event?.description} />}
        />
      </EventInfoContainer>
    ),
    [EEventManagementTabsType.BLOCKED_EVENT]: (
      <EventInfoContainer>
        <EditableInfoPanel
          mode={mode}
          name="Note :"
          editComponent={
            <CommonTextArea
              value={event?.description}
              onChange={(e) =>
                onChangeEventInfo?.({
                  type,
                  key: EEventInfoKey.DESCRIPTION,
                  value: e.target.value,
                })
              }
            />
          }
          viewComponent={<CommonTextArea disabled value={event?.description} />}
        />
      </EventInfoContainer>
    ),
    [EEventManagementTabsType.METRICS]: (
      <EventInfoContainer>
        <EditableInfoPanel
          mode={mode}
          name="Category Name:"
          editComponent={<StyledAntInput value={eventTitle} />}
          viewComponent={<StyledAntInput value={eventTitle} disabled bordered={false} />}
        />
        <EditableInfoPanel
          mode={mode}
          name="Description:"
          editComponent={<StyledAntTextArea value={eventDescription} autoSize />}
          viewComponent={
            <StyledAntTextArea value={eventDescription} autoSize disabled bordered={false} />
          }
        />
      </EventInfoContainer>
    ),
  };

  const eventEditableInfoPanel = EditableInfoPanelKit[type];

  return (
    <EventInfoCardContainer>
      <EventTitle>Details of “{event?.event_name}”</EventTitle>
      {eventEditableInfoPanel}
    </EventInfoCardContainer>
  );
};

export default EventInfoCard;
